module.exports = __webpack_public_path__ + "assets/01fe6c9eb2b3add8387199912065df40.mp3";